import { render, staticRenderFns } from "./_OrganDetail.vue?vue&type=template&id=d85bc7c4&scoped=true"
import script from "./_OrganDetail.vue?vue&type=script&lang=js"
export * from "./_OrganDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85bc7c4",
  null
  
)

export default component.exports